import { State, varioTypeMapping } from './vuex'
import { flatten, get, indexOf } from 'lodash'
import * as Helpers from './helpers'
import {
  getCruiseProduct,
  getTransportationProducts,
  getInsuranceProducts,
  getPremiumCabinDetail,
} from './booking_events'
import {
  AdobeEvent, 
  Dimension, 
  Mutation,
  CabinConfigurationDimension,
  CabinProduct,
  PaxDetail,
  Product,
  VarioTypeMapping,
} from 'pkg-trinity-client'
import { findStepIndex } from './helpers'

let previousIndex: number = 0
let tabIsSwitched: boolean = false
let previousActiveCabin: number = 0
let cabinConfigurationDimension: CabinConfigurationDimension[] = [
  { previousIndex: 0, currentIndexBeforeAbortStep: 0, lastStepCompleted: 0 },
]
let configuredCabin: any = [{ cabin: 0, data: {} }]

function buildPaxDetails(paxData: any) {
  return paxData.map((singlePax: any) => {
    const birthDate = get(singlePax, 'birthday', 'n/a')
      .value.split('.')
      .reverse()
      .join('-')
    const age = Helpers.getAge(birthDate)
    const nationality: string = get(singlePax, 'nationalityCode', 'n/a').value
    const gender: string = get(singlePax, 'sex', 'n/a').value
    return {
      gender: gender == '' ? 'n/a' : gender.toLowerCase(),
      dateOfBirth: birthDate == '' ? 'n/a' : birthDate,
      age: isNaN(age) ? 'n/a' : age.toString(),
      nationality: nationality == '' ? 'n/a' : nationality.toLowerCase(),
    }
  })
}

function handleCabins(
  cabinData: any,
  products: CabinProduct[],
  priceModel: any,
  step: number,
  shipName: string,
) {
  let cabinConfig = getPremiumCabinDetail(cabinData)
  let premiumCabinDetail = getPremiumCabinDetail(cabinData)

  let type = handleVarioCabinType(
    priceModel,
    premiumCabinDetail,
    (products && products[0].name) || 'n/a',
    shipName,
  )
  let product = buildProduct(
    type,
    cabinConfig,
    cabinData,
    step,
    priceModel,
    products,
  )
  return product
}

function handleVarioCabinType(
  priceModel: any,
  premiumCabinDetail: any,
  cabinName: string,
  shipName: string,
) {
  if (!['VARIO', 'VARIOAI', 'SEETOURS'].includes(priceModel) || cabinName == 'n/a' || shipName == 'n/a') {
    return get(premiumCabinDetail, 'subCategory', 'n/a')
  }

  if (cabinName.includes('Verandakabine Deluxe')) {
    cabinName = 'Verandakabine-Deluxe'
  } else if (cabinName.includes('Verandakabine Komfort')) {
    cabinName = 'Verandakabine-Komfort'
  } else if (cabinName.includes('Suite')) {
    cabinName = 'Suite'
  }

  let typeKey = varioTypeMapping[cabinName as keyof VarioTypeMapping]
  return typeKey
}

export const handleBookingStepCompleted = function(
  mutation: Mutation,
  state: State,
  stepIndex: number = findStepIndex(mutation.payload.to.fullPath),
  checkoutStepSkip: boolean = false,
  bookingNaming: Dimension | undefined = undefined,
  orderIdNeeded: boolean = false,
  comesFromCampaign: boolean = false,
): AdobeEvent[] {
  let totalPrice: number = 0.0
  let orderID =
    orderIdNeeded === true
      ? get(state, 'booking.general.booking.number', '')
      : undefined
  let bookings: any = get(state, 'booking')
  let activeCabin = bookings.activeCabinKey
  let event: Dimension = checkoutStepSkip
    ? 'virtualPageSkip'
    : 'virtualPageView'
  let cabinNames: any = get(state, 'booking.basket', [])
  let selectedCabin =
    cabinConfigurationDimension[bookings.basket.indexOf(activeCabin)]
  let bookingEventName =
    bookingNaming != undefined
      ? bookingNaming
      : handlebookingEventName(selectedCabin, stepIndex)

  let priceModel = get(state, 'booking.general.cruise.priceModel', 'n/a')
  let eventObject: any = []

  previousIndex = stepIndex - 1 < 0 ? 0 : stepIndex - 1
  let tempLastStep = buildTempLastStep(
    selectedCabin.lastStepCompleted,
    stepIndex,
  )

  let tempSelectedCabin = {
    previousIndex: previousIndex,
    currentIndexBeforeAbortStep: stepIndex,
    lastStepCompleted: tempLastStep,
  }

  cabinConfigurationDimension[
    bookings.basket.indexOf(activeCabin)
  ] = tempSelectedCabin

  //is necessary to prevent firing lower events but need to update cabinConfigurationDimension with current step- and tab-configuration
  if (tabIsSwitched) {
    tabIsSwitched = false
    return []
  }

  let cabinProducts = buildCabinProduct(state, cabinNames)

  if (stepIndex >= tempLastStep) {
    let cabinData = bookings[activeCabin]
    let cabinProductData = handleCabins(
      cabinData,
      flatten(cabinProducts[bookings.basket.indexOf(activeCabin)]),
      priceModel,
      cabinConfigurationDimension[bookings.basket.indexOf(activeCabin)]
        .lastStepCompleted,
      get(state, 'booking.general.cruise.shipName'),
    )
    if (
      configuredCabin[bookings.basket.indexOf(activeCabin)] &&
      configuredCabin[bookings.basket.indexOf(activeCabin)].cabin ==
        bookings.basket.indexOf(activeCabin)
    ) {
      configuredCabin[
        bookings.basket.indexOf(activeCabin)
      ].data = cabinProductData
    } else {
      configuredCabin.push({
        cabin: bookings.basket.indexOf(activeCabin),
        data: cabinProductData,
      })
    }
  }

  let totalPriceArray = cabinNames.map((cabinName: string, index: number) => {
    let cabinData = bookings[cabinName]
    totalPrice += get(cabinData, 'transportAir.rnfTotalPrice', 0.0)
    return handleCabins(
      cabinData,
      flatten(cabinProducts[index]),
      priceModel,
      cabinConfigurationDimension[index].lastStepCompleted,
      get(state, `booking.${cabinName}.general.cruise.shipName`),
    )
  })

  totalPriceArray.map((data: any) => {
    data.product.map((ele: any) => {
      if (stepIndex > 1 || totalPriceArray.length > 1) {
        totalPrice += Number(ele.price)
      }
    })
  })

  // handle entry via campgain pages
  if (comesFromCampaign)
  {
    eventObject = [ {
      event: "virtualPageView",
      booking: {
        event: 'checkoutView',
        stepNumber: (
          selectedCabin.currentIndexBeforeAbortStep + 1
        ).toString(),
        tabNumber:
          stepIndex >= 6
            ? '1'
            : (indexOf(cabinNames, activeCabin) + 1).toString(),
        tabCount: cabinNames.length.toString(),
        price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
      },
      cruise: {
        name: Helpers.buildCruiseName(state),
        ID: Helpers.getCruiseId(state, 'booking.general.cruise.id'),
        ship: Helpers.getShipName(state, 'booking.general.cruise.shipName'),
        departurePort: Helpers.getDeparturePortNameInCheckout(state),
        arrivalPort: Helpers.getArrivalPortNameInCheckout(state),
        route: get(state, 'booking.general.cruise.name', 'n/a'),
        destination: Helpers.getDestination(
          state,
          'booking.general.cruise.region',
        ),
        dateRange: `${Helpers.getStartDate(
          state,
          'booking.general.cruise.departure',
        )} bis ${Helpers.getEndDate(
          state,
          'booking.general.cruise.arrival',
        )}`,
        duration: Helpers.getDuration(
          state,
          'booking.general.cruise.duration',
        ),
        daysToCruise: Helpers.getDaysToCruise(
          state,
          'booking.general.cruise.departure',
        ),
        mandatoryFlight: Helpers.getMandatoryFlight(state, 'booking.general.cruise.mandatoryFlight', 'booking.general.cruise.priceModel'),
      }
    } ]
  }
  else if (stepIndex > 0 || bookingEventName == 'stepSwitch') 
  {
    eventObject = [
      bookingEventName == 'stepSwitch'
        ? event == 'virtualPageView'
          ? {
              event: event,
              cabin: cabinNames.map((cabinName: string, index: number) => {
                let cabinData = bookings[cabinName]
                return handleCabins(
                  cabinData,
                  flatten(cabinProducts[index]),
                  priceModel,
                  cabinConfigurationDimension[index].lastStepCompleted,
                  get(state, 'booking.general.cruise.shipName'),
                )
              }),
              booking: {
                event: bookingEventName,
                stepNumber: (
                  selectedCabin.currentIndexBeforeAbortStep + 1
                ).toString(),
                tabNumber:
                  stepIndex >= 6
                    ? '1'
                    : (indexOf(cabinNames, activeCabin) + 1).toString(),
                tabCount: cabinNames.length.toString(),
                price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
              },
            }
          : {
              event: event,
              booking: {
                stepNumber: (
                  selectedCabin.currentIndexBeforeAbortStep + 1
                ).toString(),
                tabNumber:
                  stepIndex >= 6
                    ? '1'
                    : (indexOf(cabinNames, activeCabin) + 1).toString(),
                tabCount: cabinNames.length.toString(),
                price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
              },
            }
        : orderID
        ? {
            event: event,
            cabin: cabinNames.map((cabinName: string, index: number) => {
              let cabinData = bookings[cabinName]
              return handleCabins(
                cabinData,
                flatten(cabinProducts[index]),
                priceModel,
                cabinConfigurationDimension[index].lastStepCompleted,
                get(state, 'booking.general.cruise.shipName'),
              )
            }),
            booking:
              event == 'virtualPageView'
                ? {
                    event: bookingEventName,
                    stepNumber: tempSelectedCabin.currentIndexBeforeAbortStep.toString(),
                    tabNumber:
                      stepIndex >= 6
                        ? '1'
                        : (indexOf(cabinNames, activeCabin) + 1).toString(),
                    tabCount: cabinNames.length.toString(),
                    code: orderID,
                    price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
                  }
                : {
                    stepNumber: tempSelectedCabin.currentIndexBeforeAbortStep.toString(),
                    tabNumber:
                      stepIndex >= 6
                        ? '1'
                        : (indexOf(cabinNames, activeCabin) + 1).toString(),
                    tabCount: cabinNames.length.toString(),
                    price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
                  },
          }
        : {
            event: event,
            cabin: cabinNames.map((cabinName: string, index: number) => {
              let cabinData = bookings[cabinName]
              return handleCabins(
                cabinData,
                flatten(cabinProducts[index]),
                priceModel,
                cabinConfigurationDimension[index].lastStepCompleted,
                get(state, 'booking.general.cruise.shipName'),
              )
            }),
            booking:
              event == 'virtualPageView'
                ? {
                    event: bookingEventName,
                    stepNumber: tempSelectedCabin.currentIndexBeforeAbortStep.toString(),
                    tabNumber:
                      stepIndex >= 6
                        ? '1'
                        : (indexOf(cabinNames, activeCabin) + 1).toString(),
                    tabCount: cabinNames.length.toString(),
                    price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
                  }
                : {
                    stepNumber: tempSelectedCabin.currentIndexBeforeAbortStep.toString(),
                    tabNumber:
                      stepIndex >= 6
                        ? '1'
                        : (indexOf(cabinNames, activeCabin) + 1).toString(),
                    tabCount: cabinNames.length.toString(),
                    price: Math.round(get(state, 'booking.checkout.price.fullPrice', 0)).toFixed(2)
                  },
          },
    ]
    return eventObject
  }
  return eventObject
}

export const addCabin = function(state: State): AdobeEvent[] {
  let cabinNames = get(state, 'booking.basket', [])
  let eventObject: any = []

  eventObject = [
    {
      event: 'tabAdd',
      booking: {
        stepNumber: '1',
        tabNumber: cabinNames.length.toString(),
        tabCount: cabinNames.length.toString(),
      },
    },
  ]

  cabinConfigurationDimension[cabinConfigurationDimension.length] = {
    previousIndex: 0,
    currentIndexBeforeAbortStep: 0,
    lastStepCompleted: 0,
  }

  return eventObject
}

export const removeCabin = function(state: State): AdobeEvent[] {
  let bookings: any = get(state, 'booking')
  let activeCabin = bookings.activeCabinKey
  let cabinNames: any = get(state, 'booking.basket', [])
  let eventObject: any = []
  let selectedCabin: CabinConfigurationDimension =
    cabinConfigurationDimension[previousActiveCabin]
  let tempLastStep = buildTempLastStep(1, selectedCabin.lastStepCompleted)

  eventObject = [
    configuredCabin[bookings.lastRemovedCabin] &&
    configuredCabin[bookings.lastRemovedCabin].data
      ? {
          event: 'tabRemove',
          cabin: configuredCabin[bookings.lastRemovedCabin].data,
          booking: {
            stepNumber: tempLastStep.toString(),
            tabNumber: (bookings.lastRemovedCabin + 1).toString(),
            tabCount: (cabinNames.length + 1).toString(),
          },
        }
      : {
          event: 'tabRemove',
          booking: {
            stepNumber: tempLastStep.toString(),
            tabNumber: (bookings.lastRemovedCabin + 1).toString(),
            tabCount: (cabinNames.length + 1).toString(),
          },
        },
  ]
  configuredCabin.splice(bookings.lastRemovedCabin, 1)
  previousActiveCabin = bookings.basket.indexOf(activeCabin)
  previousActiveCabin &&
    cabinConfigurationDimension.splice(previousActiveCabin, 1)
  return eventObject
}

export const switchActiveCabin = function(state: State): AdobeEvent[] {
  let event: Dimension = 'virtualPageView'
  let cabinNames = get(state, 'booking.basket', [])
  let bookings: any = get(state, 'booking')
  let activeCabin = bookings.activeCabinKey
  let eventObject: any = []
  let selectedCabin = cabinConfigurationDimension[previousActiveCabin]
  let cabinData = bookings[bookings.basket[previousActiveCabin]]
  let cabinProduct = buildCabinProduct(
    state,
    [bookings.basket[previousActiveCabin]],
    true,
  )
  if (
    configuredCabin[previousActiveCabin] &&
    configuredCabin[previousActiveCabin].data
  ) {
    configuredCabin[previousActiveCabin].data = cabinProduct
  } else {
    configuredCabin.push({
      cabin: previousActiveCabin,
      data: cabinProduct,
    })
  }
  previousIndex =
    selectedCabin.previousIndex == 0 ? 1 : selectedCabin.previousIndex + 1
  cabinConfigurationDimension[previousActiveCabin] = selectedCabin
  let priceModel = get(state, 'booking.general.cruise.priceModel', 'n/a')

  eventObject = [
    cabinProduct
      ? {
          event: event,
          cabin: [
            handleCabins(
              cabinData,
              flatten(cabinProduct),
              priceModel,
              cabinConfigurationDimension[previousActiveCabin]
                .lastStepCompleted,
              get(state, 'booking.general.cruise.shipName'),
            ),
          ],
          booking: {
            event: 'tabSwitch',
            stepNumber: previousIndex.toString(),
            tabNumber: (previousActiveCabin + 1).toString(),
            tabCount: cabinNames.length.toString(),
          },
        }
      : {
          event: event,
          booking: {
            event: 'tabSwitch',
            stepNumber: previousIndex.toString(),
            tabNumber: (previousActiveCabin + 1).toString(),
            tabCount: cabinNames.length.toString(),
          },
        },
  ]
  previousActiveCabin = bookings.basket.indexOf(activeCabin)
  tabIsSwitched = true

  setTimeout(() => {
    tabIsSwitched = false
  }, 700)

  return eventObject
}

//local helpers
function buildCabinProduct(
  state: State,
  cabinNames: any,
  tabIsSwitchedAfterInsuranceMultiCabin = false,
) {
  return cabinNames.map((cabinName: string, index: number) => {
    if (
      tabIsSwitchedAfterInsuranceMultiCabin &&
      cabinConfigurationDimension[index].lastStepCompleted == 4
    ) {
      cabinConfigurationDimension[index].lastStepCompleted = 5
    }
    let transports =
      cabinConfigurationDimension[index].lastStepCompleted >= 3
        ? getTransportationProducts(state, cabinName)
        : []

    let insurance =
      cabinConfigurationDimension[index].lastStepCompleted >= 4
        ? getInsuranceProducts(state, cabinName)
        : []
    return [
      getCruiseProduct(
        state,
        cabinName,
        cabinConfigurationDimension[index].lastStepCompleted,
      ),
      ...transports,
      ...insurance,
    ]
  })
}

function buildTempLastStep(
  lastCompletedStep: number | undefined,
  checkoutStepIndex: number,
) {
  return lastCompletedStep && lastCompletedStep > checkoutStepIndex
    ? lastCompletedStep
    : checkoutStepIndex
}

function handlebookingEventName(selectedCabin: any, stepIndex: number) {
  return !selectedCabin ||
    !selectedCabin.lastStepCompleted ||
    stepIndex > selectedCabin.lastStepCompleted
    ? 'stepComplete'
    : 'stepSwitch'
}

function buildPaxConfig(cabinData: any) {
  return `${get(cabinData, 'persons.adults', 'n/a').toString()}:${get(
    cabinData,
    'persons.juveniles',
    'n/a',
  ).toString()}:${get(cabinData, 'persons.children', 'n/a').toString()}`
}

function buildProduct(
  type: any,
  cabinConfig: any,
  cabinData: any,
  step: number,
  priceModel: any,
  products: CabinProduct[],
) {
  let product: Product = {
    product: products,
  }
  let number = cabinConfig ? cabinConfig.cabin : 'n/a'
  let position = cabinConfig ? cabinConfig.shipSection : 'n/a'
  let paxConfig = buildPaxConfig(cabinData)
  let paxDetails: PaxDetail[] = buildPaxDetails(
    get(cabinData, 'pax.paxe', 'n/a'),
  )

  paxConfig ? (product.paxConfig = paxConfig) : 'n/a'

  if (step > 1) {
    type ? (product.type = type) : 'n/a'
    number ? (product.number = number) : 'n/a'
    position ? (product.position = position) : 'n/a'
    priceModel
      ? (product.priceModel = priceModel === 'IND' ? 'PREMIUM' : priceModel)
      : 'n/a'
  }

  if (step > 3) {
    paxDetails ? (product.paxDetail = paxDetails) : 'n/a'
  }
  return product
}